<h2 mat-dialog-title mat-dialog-draggable-title>{{'title.sign_wait_list' | translate}}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onClickCancelButton()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<ng-container *ngIf="notifyWarning && dataSource.length > 0">
  <div class="mt-3">
      <span>
        <em [innerHTML]="notifyWarning | translate" class="color-fc1203"></em>
      </span>
  </div>
</ng-container>
<div *ngIf="dataSource.length > 0">
  <div
    *ngIf="typeContracts === 'mix certificate'; then mixBlock else (typeContracts === 'with certificate' ? withCerBlock : nonCerBlock)"></div>
</div>

<ng-template #mixBlock>
  <div style="display: flex;" class="pb-2 py-3">
    <div style="width: 66.7%;">
      <span>{{'search_form.sign_batch_wait' | translate}}</span>
      <span style="color: #fc1203;">&nbsp;{{dataSource.length}}</span>
      <span>{{'search_form.sign_batch_contracts' | translate}}</span>
      <span style="color: #fc1203;">{{noOfFiles}}</span>
      <span>{{'search_form.sign_batch_files' | translate}}</span>
    </div>
  </div>
</ng-template>
<ng-template #withCerBlock>
  <div style="display: flex;" class="pb-2 py-3">
    <div style="width: 130px;">
      <span>{{'search_form.approve_batch' | translate}}:</span>
    </div>
    <div style="width: 66.7%;">
      <span style="color: #fc1203;">{{conTractWithCertificate}}</span>
      <span>{{'search_form.approve_batch_contracts' | translate}}(</span>
      <span style="color: #fc1203;">{{noOfFiles}} </span>
      <span>{{'search_form.sign_batch_files' | translate}}
        ) {{'search_form.approve_batch_contracts_with_certificate' | translate}} </span>
    </div>

  </div>

</ng-template>
<ng-template #nonCerBlock>
  <div style="display: flex;" class="pb-2 py-3">
    <div style="width: 123.5px;">
      <span>{{'search_form.approve_batch' | translate}}:</span>
    </div>
    <div style="width: 66.7%;">
      <span style="color: #fc1203;">{{conTractWithoutCertificate}}</span>
      <span>{{'search_form.approve_batch_contracts_without_certificate' | translate}}</span>
    </div>

  </div>
</ng-template>
<mat-dialog-content *ngIf="dataSource.length > 0">
  <mat-table [dataSource]="dataSource">
    <!-- STT -->
    <ng-container matColumnDef="STT">
      <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
        {{'enterprise_contract.table_headers.No' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element, let i = index"
                class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()">
        {{i + 1}}
      </mat-cell>
    </ng-container>

    <!-- Tên tài liệu Column -->
    <ng-container matColumnDef="contractName">
      <mat-header-cell *matHeaderCellDef style="max-width: 55%" class="mat-cell-non-boder-right-bottom">
        {{'headertable.document_code_name' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" style="max-width: 55%" matTooltip="{{ element.name }}"
                class="mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()">
        <span class="fix-width">{{element.name}}</span>
      </mat-cell>
    </ng-container>

    <!-- Số file Column -->
    <ng-container matColumnDef="noOfFile">
      <mat-header-cell *matHeaderCellDef style="max-width: 4%" class="mat-cell-non-boder-right-bottom">
        {{'headertable.no_of_files' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" style="max-width: 4%"
                class="mat-cell-non-boder-right-bottom number-cell-center"
                (click)="$event.stopPropagation()">
                <span class="fix-width">
                    {{element.contractAttachments.length}}
                </span>
      </mat-cell>
    </ng-container>

    <!-- Tên các bên ký kết Column -->
    <ng-container matColumnDef="allName">
      <mat-header-cell *matHeaderCellDef class="mat-cell-non-border-right-bottom" >
        {{'headertable.name_of_subject_to_be_confirmed' | translate}}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" matTooltip="{{ element.signerName }}"
                (click)="$event.stopPropagation()" class="mat-cell-non-border-right-bottom">
        <span class="fix-width">{{ element.signerName ? element.signerName : element.signerConfirms}}</span>
      </mat-cell>
    </ng-container>

    <!-- Người chuyển Column -->
<!--    <ng-container matColumnDef="createdUser">-->
<!--      <mat-header-cell *matHeaderCellDef style="max-width: 18%;" class="mat-cell-non-boder-right-bottom">-->
<!--        {{'enterprise_contract.table_headers.forward_by' | translate}}-->
<!--      </mat-header-cell>-->
<!--      <mat-cell *matCellDef="let element" style="max-width: 18%;" matTooltip="{{ element.createdUser }}"-->
<!--                (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom">-->
<!--        <span class="fix-width">{{ element.createdUser}}</span>-->
<!--      </mat-cell>-->
<!--    </ng-container>-->

    <!-- Duyệt bằng CTS Column -->
<!--    <ng-container matColumnDef="isSignDigitalCertificate">-->
<!--      <mat-header-cell *matHeaderCellDef style="max-width: 18%;" class="mat-cell-non-boder-right-bottom">-->
<!--        {{'enterprise_contract.table_headers.approve_by_certificate' | translate}}-->
<!--      </mat-header-cell>-->
<!--      <mat-cell *matCellDef="let element" style="max-width: 18%"-->
<!--                matTooltip="{{ element.isSignDigitalCertificate ? 'Duyệt bằng CTS' : 'Không duyệt bằng CTS' }}"-->
<!--                (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom justify-content-center flex">-->
<!--        <mat-icon *ngIf="element.isSignDigitalCertificate" class="mr-0">done</mat-icon>-->
<!--      </mat-cell>-->
<!--    </ng-container>-->

    <!-- Ngày nhận -->
<!--    <ng-container matColumnDef="receivedTime">-->
<!--      <mat-header-cell *matHeaderCellDef class="mat-cell-non-border-right-bottom"-->
<!--                       style="max-width: 12%;">{{'headertable.received_time' | translate}}-->
<!--      </mat-header-cell>-->
<!--      <mat-cell *matCellDef="let element" matTooltip="{{ element.receivedTime | dateformat }}"-->
<!--                class="mat-cell-non-border-right-bottom number-cell-center" (click)="$event.stopPropagation()"-->
<!--                style="max-width: 12%;">-->
<!--        <span class="fix-width">{{ element.receivedTime | dateformat}}</span>-->
<!--      </mat-cell>-->
<!--    </ng-container>-->

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row">
    </mat-row>
  </mat-table>
  <!-- Pagination -->
</mat-dialog-content>
<mat-dialog-content *ngIf="dataSource.length == 0">
  <div style="margin-top: 10px;text-align: center;">Không có hợp đồng/văn bản cần ký xác nhận</div>
</mat-dialog-content>
<mat-divider class="mt-3"></mat-divider>
<mat-dialog-actions align="center">
  <button mat-stroked-button color="primary" class="mr-3" (click)="onClickCancelButton()" type="button">
    <mat-icon class="mr-0">cancel</mat-icon>
    {{'button.cancel' | translate}}
  </button>
  <button mat-raised-button cdkFocusInitial (click)="onClickConfirmButton()" color="primary" *ngIf="dataSource.length > 0">
    <mat-icon class="mr-0">done_all</mat-icon>
    {{'button.confirm' | translate}}
  </button>
</mat-dialog-actions>
